import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Account } from '@inyova/models';
import { NgxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '@strategy/strategy.actions';
import * as fromAppRoot from '@app/app.reducers';
import * as fromStrategy from '@strategy/reducers';

import { MOBILE_VIEW_TRESHOLD } from '@app/app.constants';
import { LanguageService } from '@shared/services/language.service';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-footer',
  styleUrls: ['./app-footer.component.scss'],
  templateUrl: './app-footer.component.html',
  // @angular-eslint/no-host-metadata-property
  host: { '[class.showGuarantee]': 'showGuarantee' },
  standalone: false
})
export class AppFooterComponent implements OnInit, OnDestroy {
  @Input() hideGuarantee: boolean;
  currentAccount: Account;
  tuvLanguage: string;
  showGuarantee = false;
  protected readonly onDestroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private trackingService: TrackingService,
    private languageService: LanguageService,
    private ngxZendesk: NgxZendeskWebwidgetService
  ) {
    this.tuvLanguage = this.languageService.getRedirectLanguage();

    this.store.pipe(select(fromAppRoot.selectCurrentAccount), takeUntil(this.onDestroy$)).subscribe((currentAccount) => {
      this.currentAccount = currentAccount;
    });

    this.store.pipe(select(fromStrategy.selectGuaranteeVisibility), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.showGuarantee = value;
    });
  }

  ngOnInit() {
    this.getZendeskElement('none');
  }

  getZendeskElement(action: string): void {
    if (window.innerWidth < MOBILE_VIEW_TRESHOLD || this.hideGuarantee) {
      return;
    }

    const floatingZendesk = document.getElementsByClassName('floating')[0] as HTMLElement;
    if (floatingZendesk) {
      floatingZendesk.style.display = action;
    }
  }

  ngOnDestroy(): void {
    this.getZendeskElement('flex');
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  toggleGuaranteeModal(): void {
    this.store.dispatch(StrategyActions.setGuaranteeVisibility({ value: !this.showGuarantee }));
    this.trackingService.trackActivity(`[Modal] Guarantee`);
  }

  launchZendesk() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.ngxZendesk.zE.activate();
  }
}
